module.exports = __webpack_public_path__ + "media/pages/assets/images/thumbs-up-8229e4c21a251a89c59526c35884bc28.svg";